import React from 'react';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Button from '@marvelapp/marvel-ui/button';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Align from '@marvelapp/marvel-ui/align';
import Link from '@marvelapp/marvel-ui/link';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';

import IntegrationsCta from 'marketing-website/components/modules/IntegrationsCta';
import Image from 'marketing-website/components/modules/Image';
import Page from 'marketing-website/components/modules/Page';

import pdfs from 'marketing-website/configs/pages/sketchpad/pdf.js';
import metaData from 'marketing-website/data/metadata.js';

import styles from './style/general.module.css';

export default function WhyMarvel() {
  const pdfItems = pdfs.map(pdf => (
    // Only do this if items have no stable IDs
    <GridItem columnSpan={3} columnSpanM={1} key={pdf.id}>
      <Align type="center">
        <div className={styles.thumbnail}>
          <Image {...pdf.asset} />
        </div>
        <Spacing size="s" type="padding" position="topBottom">
          <Grid columns={2} alignItems="center" size="m">
            <GridItem>
              <Align type="left">{pdf.name}</Align>
            </GridItem>
            <GridItem>
              <Align type="right">
                <Link url={pdf.file} target="_blank" data-bypass>
                  <Button size="medium" shape="rounded">
                    Download
                  </Button>
                </Link>
              </Align>
            </GridItem>
          </Grid>
        </Spacing>
      </Align>
    </GridItem>
  ));

  return (
    <Page
      title={metaData.sketchpad.title}
      meta={[
        {
          name: 'description',
          content: metaData.sketchpad.description,
        },
      ]}
      header
      footer
    >
      <div className="overflow-hidden">
        <div className={styles.wrap}>
          <h1 className={styles.heading}>Sketch Pads</h1>
          <Spacing size="l" type="padding" position="bottom">
            <MaxWidth value={720}>
              <p className={styles.subheading}>
                Need something to draw on? Download our free printable templates
                and bring your ideas to life.
              </p>
            </MaxWidth>
          </Spacing>
          <PageWrap>
            <Grid columns={3} size="l">
              {pdfItems}
            </Grid>
          </PageWrap>
        </div>

        <IntegrationsCta />
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/sketchpad/index.js